import { render } from "./FormTextAuto.vue?vue&type=template&id=0b5c0c1a"
import script from "./FormTextAuto.vue?vue&type=script&lang=js"
export * from "./FormTextAuto.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/Form/FormTextAuto.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b5c0c1a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b5c0c1a', __exports__)) {
    console.log('reload')
    api.reload('0b5c0c1a', __exports__)
  }
  
  module.hot.accept("./FormTextAuto.vue?vue&type=template&id=0b5c0c1a", () => {
    console.log('re-render')
    api.rerender('0b5c0c1a', render)
  })

}


export default __exports__